module.exports = __webpack_public_path__ + "files/fb5627ba57d5d2f97beef27fbbcfcb90.svg";